import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Howl } from 'howler';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import { Buffer } from 'buffer';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import IconButton from '@mui/material/IconButton';

import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import InfoIcon from '@material-ui/icons/Info';
import Tooltip from "@material-ui/core/Tooltip";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Typography from '@material-ui/core/Typography';
import MessageView from './MessageView';
import UserList from './UserList';
import StatusMessageArea from './StatusMessageArea';
import Common from '../Common';
import Moment from 'moment';
import axios from 'axios';
import LineBack_Image from "../../lineBack.png";
import CSVButton from "./CSVButton.js";
import SendButton from "./SendButton.js";
import ClickAwayListener from '@mui/material/ClickAwayListener';

Moment.locale('ja');

const styles = theme => ({
    root: {
        height: "100%"
    },
    flex: {
        display:'flex'
    },
    chat_width: {
        marginTop: '10px',
        width: '100%',
        display: "flex",
        justifyContent: "center",
    },
    info_icon_position: {
        position: "relative",
        left: "30px",
        color: "rgba(0, 0, 0, 0.87)"
    },
    chat_paper_top: {
        padding: "2px",
        alignItems: "center",
        height: '36px',
        display: "flex",
        boxShadow: "none",
        backgroundColor: "#4EDE80",
        borderRadius: "0px 0px 0px 0px"
    },
    chat_paper_middle: {
        height: "500px",
        overflow: 'auto',
        boxShadow: "none",
        backgroundImage: `url(${LineBack_Image})`,
        borderRadius: "0px 0px 0px 0px"
    },
    chat_paper_bottom: {
        alignItems: "center",
        //height: "263px",
        height: "170px",
        backgroundColor: "#E0E0E0",
        borderRadius: "0px 0px 0px 0px"
    },
    chat_paper_userName: {
        left: "5px",
        position: "relative"
    },
    userList_customize_area: {
        display: "flex",
        borderRadius: "0",
        boxShadow: "none",
        position: "relative",
    },
    userList_checkBox_area: {
        marginLeft: "10px"
    },
    counselingKubun_pullDown: {
        marginLeft: "auto",
    },
    userList_counselingKubunName_list: {
        marginLeft: theme.spacing(),
        marginRight: theme.spacing(),
        width: "320px",
        top: "7px"
    },
    userList_counselingKubunName_list2: {
        margin: theme.spacing() * 1,
        width: "320px",
    },
    userList_paper_top: {
        alignItems: "center",
        height: "40px",
        maxHeight: "100px",
        display: "flex",
        boxShadow: "none",
        backgroundColor: "#4EDE80",
        borderRadius: "0px 0px 0px 0px"
    },
    userList_paper_string: {
        margin: "0 auto",
        color: "white",
        fontSize: "21px",
        // fontWeight: "bold"
    },
    userList_paper_middle: {
        height: "455px",
        boxShadow: "none",
        overflow: 'auto',
        backgroundColor: "#E0E0E0",
        borderRadius: "0px 0px 0px 0px"
    },
    userList_paper_bottom: {
        border: "1px solid #949494",
        boxShadow: "none",
        maxHeight: "510px",
        backgroundColor: "white",
        borderRadius: "0px 0px 0px 0px"
    },
    send_message_area: {

    },
    textField_font_risize: {
        fontSize: "12px",
    },
    message_validator: {
        width: '80%',
        height: '85px',
        margin: theme.spacing() * 1,
    },
    message_validator_dialogVersion: {
        width: '97%',
        margin: theme.spacing() * 1,
    },
    dialog_content: {
        width: "500px",
        padding: "5px",
        marginTop: "10px"
    },
    bottom_button_area: {
        float: "right"
    },
    csv_button_area: {
        float: "left"
    },
    csv_button_disable_area: {
        marginTop: '40px',
        float: "left"
    },
    bottom_button_area_dialogVersion: {
        top: "5px",
        position: "relative",
        float:"right"
    },
    dialog_content_count: {
        float: "right",
    },
    button_template: {
        height: "35px",
        top: "10px",
        left: "5px",
        position: "relative",
        margin: "0px 5px 5px 0px",
    },
    button_userTemplate_color:{
        backgroundColor: "#F56565",
        '&:hover': {
            backgroundColor: "#F9A4A4",
        },
        color: "white",
    },
    button_systemTemplate_color:{
        backgroundColor: "#979797",
        '&:hover': {
            backgroundColor: "#C4C3C3",
        },
        color: "white",
    },
    button_expansion_message_input_area: {
        //marginTop:'18px',
        width: "50px",
        height: "50px",
        top: "10px",
        margin: "0px 0px 0px 5px",
        position: "relative",
        backgroundColor: "#979797",
        '&:hover': {
            backgroundColor: "#C4C3C3",
        }
    },
    button_send: {
        margin: theme.spacing() * 1,
        color: "white",
        width: "93px",
        backgroundColor: "#4EDE80",
        '&:hover': {
            backgroundColor: "#8AD68A",
        }
    },
    button_close: {
        margin: theme.spacing() * 1,
        color: "#F94141",
        border: "solid 1px #F94140",
        backgroundColor: "white",
        '&:hover': {
            backgroundColor: "#FFEEEE",
        }
    },
    button_counseling_start_or_reStart: {
        textAlign: "center",
        height: "100px"
    },
    button_counseling_start: {
        height: "70px",
        width: "80%",
        backgroundColor: "#63A8DD",
        top: "30px",
        color: "white",
        fontSize: "20px",
        position: "relative",
        '&:hover': {
            backgroundColor: "#90C3EA",
        }
    },
    //未対応の状態
    supported_status: {
        padding: "0.5em 1em",
        marginLeft: "auto",
    },
    supported_status_p: {
        margin: "0",
        padding: "0",
    },
    dialog_root: {
        height: "70%"
    },
    dialog_title: {
        backgroundColor: "#4EDE80",
        borderBottom: "solid 2px gray",
        padding: "10px 10px",
    },
    //未選択の色
    supported_status_notSelect: {
        color: "#FFF",
        background: "#808080",
    },
    //未対応の色
    supported_status_notSupport: {
        color: "#FFF",
        background: "#EB5D00",
    },
    //対応中の色
    supported_status_supporting: {
        color: "#FFF",
        background: "#5D86FF",
    },
    //中断の色
    supported_status_interruption: {
        color: "#FFF",
        background: "#FF5917",
    },
    //返答なしの色
    supported_status_end: {
        color: "#FFF",
        background: "#808080",
    },
    //完了の色
    supported_status_finish: {
        color: "#FFF",
        background: "#808080",
        fontSize: "14px"
    },
    textField: {
        marginLeft: theme.spacing(),
        marginRight: theme.spacing(),
        width: "135px",
        background: "white",
        textAlign: "left"
    },
    userList_counselingKubunName_select: {
        border: "1px solid #949494",
        borderBottom: "0",
        paddingLeft: "5px"
    },
    pullDown_style: {
        maxHeight: "300px"
    },
    input: {
        width: '185px',
    },
    past_counselingButton:{
        position:'relative',
        left : '40px',
        marginRight: '20px'
    },
    margin:{
        '& > label': {
            marginTop: '5px'
        }
    },
    tooltip:{
        marginLeft: '-14px'
    }
});

const reloadTimesArray = [
    {
        value: 5,
        label: '5秒毎に更新',
    },
    {
        value: 15,
        label: '15秒毎に更新',
    },
    {
        value: 30,
        label: '30秒毎に更新',
    },
    {
        value: 45,
        label: '45秒毎に更新',
    },
    {
        value: 60,
        label: '60秒毎に更新',
    },
];

const HtmlTooltip = withStyles(theme => ({
    tooltip: {
        backgroundColor: "rgba(245, 245, 245, 0.9)",
        color: "rgba(0, 0, 0, 0.87)",
        maxWidth: 420,
        wordWrap: "break-word",
        whiteSpace: "pre-wrap",
        fontSize: theme.typography.pxToRem(15),
        border: "2px solid #808080"
    }
}))(Tooltip);

//メッセージ取得の更新頻度（ミリ秒）
const updateIntervalTime = 60000;

class Chat extends Component {
    constructor(props) {
        super(props);
        const commonNameObj = this.props.cookies.get('COMMON_NAME_OBJ');
        this.state = {
            //ログイン中のユーザ
            supportedPersonId: this.props.cookies.get('supportedPersonId'),
            //チャット区分格納配列
            counselingKubunArray: [],

            //対応区分格納配列
            responsibleKubunArray: [],

            //完了したチャットを表示するかどうか
            checkedEnd: false,

            //自分以外の対応者も表示するかどうか
            checkedNonSelf: false,

            //テキスト入力欄の状態
            //01 : 入力可能状態
            //02 : 対応開始状態
            //03 : 対応再開状態
            //04 : 入力不可状態
            inputMessageAreaStatus: "01",

            // ユーザリスト配列
            userListsArray: [],

            //選択されたユーザ名
            selectedUserName: "",

            //選択されたユーザID
            selectedUserId: "",

            //選択されたユーザの中断理由
            selectedInterruptedCauseMemo: "",

            //更新チェックを行うためのstate
            selectedInterruptedCauseMemoLog: "",

            //選択されたチャット区分名
            selectedCounselingKubunName: "",

            //選択されたチャット区分ID
            selectedCounselingKubunId: "00",

            //直接チャット時に選択されたチャット区分ID
            selectedDirectCounselingKubunId: "",

            //選択されたチャットを対応しているユーザID
            selectedCounselingSupportedPersonId:"",

            //選択中のユーザの過去チャットを表示するかどうかのフラグ
            checkedPastCounseling: false,

            //検索したいキーワードを入力する文字列
            searchingCounselingKeyword:"",

            //選択されたチャット情報番号
            selectedCounselingInfoNumber: "",

            //選択されたチャット情報のチャット情報
            selectedCounselingUserData:{
                fullName:"",
                counselingKubunName:"",
                chatId: ""
            },

            //開いているユーザとのチャットを格納する配列
            messagesArray: [],

            //送信メッセージ
            inputMessage: "",

            //定型文一覧の表示非表示を管理する
            userTemplateOpenFlg: false,
            systemTemplateOpenFlg: false,

            //クリックしたボタンの位置を保持(templateOpenFlgとセット)
            anchorEl: null,

            //statusMessageAreaに表示する文字列
            statusMessageAreaContent: "",

            //取得した定型文を格納する配列
            // templatesArray: [],
            userTemplatesArray:[],
            systemTemplatesArray: [],

            //選択された定型文IDを保持する
            selectedTemplateId: "",

            //選択された定型文タイプを保持する
            selectedTemplateMessageType: "",

            //指定選択されたユーザの対応状況
            supportedStatusName: "未選択",

            //送信テキスト拡張ダイアログのオンオフフラグ
            expansionInputTextAreaOpenFlag: false,

            reloadTime: 30,
            secondsElapsed: 30,
            isStart: false,
            memoInputAvailabilityFlag:false,

            counselingDirectUserId: "",
            tooltipOpen: false,

            incrementalMessagesErrCount: 0,
            userListDataErrCount : 0,
            seachingCounselingDataErrCount: 0,

            talkName: commonNameObj !== undefined ? commonNameObj.TALK_NAME : 'チャット'

        };

        //会話増分チェックを行う関数で使用
        this.setIntervalId = "";
        //一番最新のメッセージのID(増分チェックでこれ以降の者を取得)
        this.conversationId = "";
        //ユーザリストの連打防止
        this.updateFlag = true;
        //送信ボタンの連打防止
        this.buttonControlFlag = true;

        this.tick = this.tick.bind(this);
    }
    _isMounted = false;

    getb2cInfo(token) {
        const baseArray = token.split('.');
        const userData = JSON.parse(Buffer.from(baseArray[1].replace(/-/g, '+').replace(/_/g, '/'), 'base64').toString());
        return userData;
    }

    //-----------------------------------------------------------------
    //Azure AD 認証
    //-----------------------------------------------------------------
    getData() {
        const { cookies } = this.props;
        const id_token = cookies.get('id_token');
        if(id_token === undefined && !window.location.hash.match('#id_token=')){
            window.location.href = process.env.REACT_APP_AUTH_URL;
        }
        else if(cookies.get('supporterFullName') === undefined || cookies.get('supporterFullName') === ''){
            window.location.href = '/';
        }
        else{
            if(id_token !== undefined && !window.location.hash.match('#id_token=')){
                const token = id_token;
                //b2cログイン情報取得
                const userData = this.getb2cInfo(token);
                //UNIXを一般的な時間しトークンの有効期限を取得
                const expDate = new Date(userData.exp * 1000);
                const now = new Date();
                //現在の時間が有効期限を過ぎていたらログイン画面を表示
                if(expDate <= now){
                    window.location.href = process.env.REACT_APP_AUTH_URL;
                }
            }
            if(window.location.hash.match('#id_token=')){
                cookies.set('id_token', window.location.hash.replace('#id_token=',''), {
                    maxAge: 60 * 60 * 24 * 1, //1日間
                    httpOnly: false,
                    path: '/',
                    secure: true,
                });
            }
            this.getData_();
        }
        this.getResponsibleKubun();//区分取得
    }

    getData_ = () => {
        const { cookies } = this.props;
        const idToken = cookies.get('id_token');
        //----------------------------
        //トークンを取得
        //----------------------------
        axios.post(
            `${Common.apiServerUrl()}/api/auth/token`,
            {},
            {
                headers: {
                    'Authorization': 'Bearer ' + idToken
                },
            }

        )
        .then(Common.handleErrors)
        .then(tokenResponse => {
            //successはbool型
            if (tokenResponse.success) {
                //tokenをセット
                cookies.set('token', tokenResponse.token);
                this.updateUserList();
                if(this.state.userTemplatesArray.length === 0 && this.state.systemTemplatesArray.length === 0){
                    this.getTemplate();
                }
            } else {
                //token取得に失敗したメッセージをアラートで表示
            }
        })
        .catch(err => {
            // alert(`code:${err.code} ${err.error_usermsg}`);
            alert(`code : [getResponsibleKubun]\nmessage : エラーが発生しました。サポートに連絡してください。`);
            console.log(err);
        })
    }

    //--------------------------------
    // 適切なユーザリスト更新関数を実行
    //--------------------------------
    updateUserList = () => {
        // 過去チャット閲覧フラグがtrueの場合に実行
        if(this.state.checkedPastCounseling){
            this.getPastCounselingData();
        //チャット番号が入力されている場合に実行
        }else if(this.state.searchingCounselingKeyword !== ""){
            this.getSeachingCounselingData();
        //それ以外の場合は通常通り未対応取得
        }else{
            // this.getUnsupportedData();
            this.getUserListData();
        }
    }


    //----------------------------
    //　担当区分を取得
    //----------------------------
    getResponsibleKubun = () => {
        const { cookies } = this.props;
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');
        axios.get(
            `${Common.apiServerUrl()}/api/counseling/getResponsibleKubun`,
            {
                // mode: 'cors',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
                params: {
                    supportedPersonId: this.state.supportedPersonId
                }
            }
        )
        .then(Common.handleErrors)
        .then(getResponsibleKubunResponse => {
            if (getResponsibleKubunResponse.success) {
                //担当区分が返却された場合のみ割り当てる
                if (getResponsibleKubunResponse.getResponsibleKubunArray.length !== 0){
                    this.setState({ counselingKubunArray: getResponsibleKubunResponse.getResponsibleKubunArray });
                    this.setState({ selectedCounselingKubunId: getResponsibleKubunResponse.getResponsibleKubunArray[0].counselingKubunId })
                }
                //対応：ここのsetStateは担当区分がない場合にはERRORになる
            } else {
                alert(`code : [${getResponsibleKubunResponse.code}]\nmessage : ${getResponsibleKubunResponse.error_usermsg}`);
            }
        })
        .catch(err => {
            console.log(err);
            if (Object.keys(err).indexOf('data') !== -1) {
                alert(`code : [${err.code}]\nmessage : ${err.error_usermsg}`);
            } else {
                alert(`code : [getResponsibleKubun]\nmessage : エラーが発生しました。サポートに連絡してください。`);
            }
        })
    }
    //-----------------------------------------------------------------
    //   定型文の取得（担当区分が選択されていない場合は全件取得）
    //-----------------------------------------------------------------
    getTemplate = () => {
        const { cookies } = this.props;
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');
        //----------------------------
        //　チャット区分を取得
        //----------------------------
        axios.get(
            `${Common.apiServerUrl()}/api/template/getTemplate`,
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
                data: {}
            }
        )
        .then(Common.handleErrors)
        .then(getTemplateResponse => {
            if (getTemplateResponse.success) {
                this.setState({userTemplatesArray : getTemplateResponse.userTemplate});
                this.setState({systemTemplatesArray : getTemplateResponse.systemTemplate});
            } else {
                alert(`code : [${getTemplateResponse.code}]\nmessage : ${getTemplateResponse.error_usermsg}`);
            }
        })
        .catch(err => {
            console.log(err);
            if (Object.keys(err).indexOf('data') !== -1) {
                alert(`code : [${err.code}]\nmessage : ${err.error_usermsg}`);
            } else {
                alert(`code : [getTemplate]\nmessage : エラーが発生しました。サポートに連絡してください。`);
            }
        })
    }

    //-----------------------------------------------------------------
    //              UserListの取得
    //-----------------------------------------------------------------
    getUserListData = () => {
        const { cookies } = this.props;
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');
        axios.get(
            `${Common.apiServerUrl()}/api/counseling/getUserList`,
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
                params: {
                    supportedPersonId: this.state.supportedPersonId,
                    counselingKubun: this.state.selectedCounselingKubunId,
                    completedFlg: this.state.checkedEnd,
                    nonSelfFlg: this.state.checkedNonSelf
                },
                data: {}
            }
        )
        .then(Common.handleErrors)
        .then(getuserListResponse => {
            // 取得成功
            if (getuserListResponse.success) {
                getuserListResponse.userListsArray.sort(function(a, b){
                    if(a.supportedStatus === '0') return -1;
                    else if(b.supportedStatus === '0') return 1;
                    else if(a.supportedStatus === '1' && b.supportedStatus === '1') {
                        const a1 = Moment(a.counselingStartTime).isSameOrAfter(Moment(a.lastSupportedTime)) ? a.counselingStartTime : a.lastSupportedTime;
                        const a2 = Moment(a1).isSameOrAfter(Moment(a.lastCounselingTime)) ? a1 : a.lastCounselingTime;
                        const b1 = Moment(b.counselingStartTime).isSameOrAfter(Moment(b.lastSupportedTime)) ? b.counselingStartTime : b.lastSupportedTime;
                        const b2 = Moment(b1).isSameOrAfter(Moment(b.lastCounselingTime)) ? b1 : b.lastCounselingTime;
                        return Moment(a2).isSameOrAfter(Moment(b2)) ? -1 : 1;
                    }
                    else if(a.supportedStatus === '1') return -1;
                    else if(b.supportedStatus === '1') return 1;
                    //チャット最終日時（ユーザーが最後にメッセージを送信した時間）のどちらかが空文字の場合はチャット開始日で比較する
                    else if(a.lastCounselingTime === '' && b.lastCounselingTime === '') {
                        return Moment(a.counselingStartTime).isSameOrAfter(Moment(b.counselingStartTime)) ? -1 : 1;
                    }
                    else if(a.lastCounselingTime !== '' && b.lastCounselingTime === '') return -1;
                    else if(a.lastCounselingTime === '' && b.lastCounselingTime !== '') return 1;
                    else return Moment(a.lastCounselingTime).isSameOrAfter(Moment(b.lastCounselingTime)) ? -1 : 1;
                });
                //取得に成功した場合はエラーカウントをリセット
                this.setState({ userListDataErrCount : 0 });
                this.setState({ userListsArray: getuserListResponse.userListsArray });
            } else {
                let errCount = this.state.userListDataErrCount;
                errCount++;
                //10回連続でエラーが発生した場合にアラートを表示する
                if(errCount >= 10){
                    alert(`code : [${getuserListResponse.code}]\nmessage : ${getuserListResponse.error_usermsg}`);
                }
                this.setState({ errCount });
            }
        }).catch(err => {
            console.log(err);
            if (Object.keys(err).indexOf('data') !== -1) {
                alert(`code : [${err.code}]\nmessage : ${err.error_usermsg}`);
            } else {
                let errCount = this.state.userListDataErrCount;
                errCount++;
                //10回連続でエラーが発生した場合にアラートを表示する
                if(errCount >= 10){
                    alert(`code : [getUserListData]\nmessage : エラーが発生しました。サポートに連絡してください。`);
                }
                this.setState({ userListDataErrCount: errCount });
            }
        })
    }

    //-----------------------------------------------------------------
    // 指定ユーザの過去のチャットを取得する
    //-----------------------------------------------------------------
    getPastCounselingData = () => {
        const { cookies } = this.props;
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');
        axios.get(
            `${Common.apiServerUrl()}/api/counseling/getCounselingList/userId`,
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
                params: {
                    userId : this.state.selectedUserId,
                    supportedPersonId: this.state.supportedPersonId,
                }
            }
        )
        .then(Common.handleErrors)
        .then(getCounselingListResponse => {
            if (getCounselingListResponse.success) {
                getCounselingListResponse.counelingListArray.sort(function(a, b){
                    if(a.supportedStatus === '0') return -1;
                    else if(b.supportedStatus === '0') return 1;
                    //チャット最終日時（ユーザーが最後にメッセージを送信した時間）のどちらかが空文字の場合はチャット開始日で比較する
                    else if(a.lastCounselingTime === '' && b.lastCounselingTime === '') {
                        return Moment(a.counselingStartTime).isAfter(Moment(b.counselingStartTime)) ? -1 : 1;
                    }
                    else if(a.lastCounselingTime !== '' && b.lastCounselingTime === '') return -1;
                    else if(a.lastCounselingTime === '' && b.lastCounselingTime !== '') return 1;
                    else return Moment(a.lastCounselingTime).isAfter(Moment(b.lastCounselingTime)) ? -1 : 1;
                });
                this.setState({ userListsArray: getCounselingListResponse.counelingListArray });

            } else {
                alert(`code : [${getCounselingListResponse.code}]\nmessage : ${getCounselingListResponse.error_usermsg}`);
            }
        }).catch(err => {
            console.log(err);
            if (Object.keys(err).indexOf('data') !== -1) {
                alert(`code : [${err.code}]\nmessage : ${err.error_usermsg}`);
            } else {
                alert(`code : [getPastCounselingData]\nmessage : エラーが発生しました。サポートに連絡してください。`);
            }
        })
    }

    //-----------------------------------------------------------------
    //              チャット情報検索
    //-----------------------------------------------------------------
    getSeachingCounselingData = () => {
        const { cookies } = this.props;
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');

        axios.get(
            `${Common.apiServerUrl()}/api/counseling/getCounselingList/search`,
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
                params: {
                    supportedPersonId: this.state.supportedPersonId,
                    counselingKubun: this.state.selectedCounselingKubunId,
                    completedFlg: this.state.checkedEnd,
                    nonSelfFlg: this.state.checkedNonSelf,
                    counselingKeyword: this.state.searchingCounselingKeyword
                },
                data: {}
            }
        )
        .then(Common.handleErrors)
        .then(getSeachingCounselingDataResponse => {
            // 取得成功
            if (getSeachingCounselingDataResponse.success) {
                getSeachingCounselingDataResponse.userListsArray.sort(function(a, b){
                    if(a.supportedStatus === '0') return -1;
                    else if(b.supportedStatus === '0') return 1;
                    //チャット最終日時（ユーザーが最後にメッセージを送信した時間）のどちらかが空文字の場合はチャット開始日で比較する
                    else if(a.lastCounselingTime === '' && b.lastCounselingTime === '') {
                        return Moment(a.counselingStartTime).isAfter(Moment(b.counselingStartTime)) ? -1 : 1;
                    }
                    else if(a.lastCounselingTime !== '' && b.lastCounselingTime === '') return -1;
                    else if(a.lastCounselingTime === '' && b.lastCounselingTime !== '') return 1;
                    else return Moment(a.lastCounselingTime).isAfter(Moment(b.lastCounselingTime)) ? -1 : 1;
                });
                //取得に成功した場合はエラーカウントをリセット
                this.setState({ seachingCounselingDataErrCount : 0 });
                this.setState({ userListsArray: getSeachingCounselingDataResponse.userListsArray });
            } else {
                alert(`code : [${getSeachingCounselingDataResponse.code}]\nmessage : ${getSeachingCounselingDataResponse.error_usermsg}`);
            }
        }).catch(err => {
            console.log(err);
            if (Object.keys(err).indexOf('data') !== -1) {
                alert(`code : [${err.code}]\nmessage : ${err.error_usermsg}`);
            } else {
                let errCount = this.state.seachingCounselingDataErrCount;
                errCount++;
                //10回連続でエラーが発生した場合にアラートを表示する
                if(errCount >= 10){
                    alert(`code : [getUserListData]\nmessage : エラーが発生しました。サポートに連絡してください。`);
                }
                this.setState({ seachingCounselingDataErrCount: errCount });
            }
        })
    }


    //-----------------------------------------------------------------
    // チャット情報番号の会話履歴を取得する
    //-----------------------------------------------------------------
    getMessagesArray = () => {
        const { cookies } = this.props;
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');
        //別なチャット情報番号の会話履歴が取得された場合。
        clearInterval(this.setIntervalId);
        axios.get(
            `${Common.apiServerUrl()}/api/message/getMessageLog`,
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
                data: {},
                params: {
                    counselingInfoNumber: this.state.selectedCounselingInfoNumber
                }
            }
        )
        .then(Common.handleErrors)
        .then(getMessageLogResponse => {
            //正常にデータが取得できた場合、もう一度処理を受け付ける
            this.updateFlag = true;
            if (getMessageLogResponse.success) {
                // 最後に受信したメッセージ送信時間
                this.conversationId = getMessageLogResponse.conversationId;
                this.setState({ messagesArray: getMessageLogResponse.messagesArray},
                ()=>{
                    //2秒ごとに増分チェック
                    this.setIntervalId = setInterval(this.updateMessagesArray, updateIntervalTime);
                });
            } else {
                alert(`code : [${getMessageLogResponse.code}]\nmessage : ${getMessageLogResponse.error_usermsg}`);
            }
        })
        .catch(err => {
            //正常にデータが取得できた場合、もう一度処理を受け付ける
            this.updateFlag = true;
            console.log(err);
            if (Object.keys(err).indexOf('data') !== -1) {
                alert(`code : [${err.code}]\nmessage : ${err.error_usermsg}`);
            } else {
                alert(`code : [handleClick_get_messagesArray]\nmessage : エラーが発生しました。サポートに連絡してください。`);
            }
        })
    }

    //-----------------------------------------------------------------
    // ユーザが選択されていれば会話履歴増分チェックを呼び、されていなければ呼ばない
    //-----------------------------------------------------------------
    updateMessagesArray = () => {
        if (this.state.selectedCounselingInfoNumber !== "") this.getIncrementalMessages();
    }
    //-----------------------------------------------------------------
    // チャット情報番号の増分会話履歴を取得する
    //-----------------------------------------------------------------
    getIncrementalMessages = () => {
        const { cookies } = this.props;
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');
        axios.get(
            `${Common.apiServerUrl()}/api/message/getMessageLog/incremental`,
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
                data: {},
                params: {
                    counselingInfoNumber: this.state.selectedCounselingInfoNumber,
                    conversationId: this.conversationId
                }
            }
        )
        .then(Common.handleErrors)
        .then(getIncMessageLogResponse => {
            const Sounds = new Howl({
                src: ["/SponSound.mp3"]
            });
            if (getIncMessageLogResponse.success) {
                if (getIncMessageLogResponse.messagesArray.length !== 0) {
                    let msgArray = this.state.messagesArray;
                    //最終送信日時を更新
                    this.conversationId = getIncMessageLogResponse.conversationId;
                    //取得に成功した場合はエラーカウントをリセット
                    this.setState({ incrementalMessagesErrCount : 0 });
                    //会話配列更新
                    this.setState({ messagesArray: msgArray.concat(getIncMessageLogResponse.messagesArray) },()=>{
                        Sounds.play();//ここで通知音を再生
                    });
                }

            } else {
                clearInterval(this.setIntervalId);
                let errCount = this.state.incrementalMessagesErrCount;
                errCount++;
                //20秒間連続でエラーが発生した場合にアラートを表示する
                if(errCount >= 10){
                    alert(`code : [${getIncMessageLogResponse.code}]\nmessage : ${getIncMessageLogResponse.error_usermsg}`);
                }
                this.setState({ incrementalMessagesErrCount: errCount });
            }
        })
        .catch(err => {
            clearInterval(this.setIntervalId);
            console.log(err);
            if (Object.keys(err).indexOf('data') !== -1) {
                alert(`code : [${err.code}]\nmessage : ${err.error_usermsg}`);
            } else {
                let errCount = this.state.incrementalMessagesErrCount;
                errCount++;
                //20秒間連続でエラーが発生した場合にアラートを表示する
                if(errCount >= 10){
                    alert(`code : [getIncrementalMessages]\nmessage : エラーが発生しました。サポートに連絡してください。`);
                }
                this.setState({ incrementalMessagesErrCount: errCount });
            }
        })
    }

    //-----------------------------------------------------------------
    // 左上の情報ボタンホバー時に表示するデータを取得
    //-----------------------------------------------------------------
    getDisplayUserInfo = () => {
        const { cookies } = this.props;
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');
        axios.get(
            `${Common.apiServerUrl()}/api/counseling_log/displayUserInfo`,
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
                data: {},
                params: {
                    counselingInfoNumber: this.state.selectedCounselingInfoNumber
                }
            }
        )
        .then(Common.handleErrors)
        .then(getDisplayUserInfoResponse => {
            if (getDisplayUserInfoResponse.success) {
                this.setState({ selectedCounselingUserData: getDisplayUserInfoResponse.userInfo});
            } else {
                // clearInterval(this.setIntervalId);
                alert(`code : [${getDisplayUserInfoResponse.code}]\nmessage : ${getDisplayUserInfoResponse.error_usermsg}`);
            }
        })
        .catch(err => {
            // clearInterval(this.setIntervalId);
            console.log(err);
            if (Object.keys(err).indexOf('data') !== -1) {
                alert(`code : [${err.code}]\nmessage : ${err.error_usermsg}`);
            } else {
                alert(`code : [getDisplayUserInfo]\nmessage : エラーが発生しました。サポートに連絡してください。`);
            }
        });
    }

    //-----------------------------------------------------------------
    // 定型文を相手に送信する
    //-----------------------------------------------------------------
    postTemplate = () => {
        const { cookies } = this.props;
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');
        clearInterval(this.setIntervalId);
        axios.post(
            `${Common.apiServerUrl()}/api/template/postTemplate`,
            {
                supportedPersonId: this.state.supportedPersonId,
                counselingInfoNumber: this.state.selectedCounselingInfoNumber,
                userId: this.state.selectedUserId,
                templateId: this.state.selectedTemplateId,
            },
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
            }
        )
        .then(Common.handleErrors)
        .then(postTemplateResponse => {
            //正常終了するとボタンがクリック可能にする。
            this.buttonControlFlag = true;
            //successはbool型
            if (postTemplateResponse.success) {
                this.setState({ supportedStatusName: postTemplateResponse.supportedStatusName });
                // this.updateUserList();
                //WEBHOOKでのデータ更新の終了は待てないので、3秒後に更新
                this.updateUserList()
                this.updateInputMessageAreaStatus(postTemplateResponse, "POST_TEMPLATE");
                this.handleClick_popUpAreaClose();
                this.updateMessagesArray();
            } else {
                alert(`code : [${postTemplateResponse.code}]\nmessage : ${postTemplateResponse.error_usermsg}`);
                this.handleClick_popUpAreaClose();
                this.setState({ inputMessageAreaStatus: "04" });
            }
        })
        .catch(err => {
            //正常終了するとボタンがクリック可能にする。
            this.buttonControlFlag = true;
            console.log(err);
            if (Object.keys(err).indexOf('data') !== -1) {
                alert(`code : [${err.code}]\nmessage : ${err.error_usermsg}`);
            } else {
                alert(`code : [postTemplate]\nmessage : エラーが発生しました。サポートに連絡してください。`);
            }
        })
    }

    //-----------------------------------------------------------------
    // 送信メッセージ入力エリアの状態を変更する
    //-----------------------------------------------------------------
    updateInputMessageAreaStatus = (data, identifier) =>{
        //01 : 入力可能状態
        //02 : 対応開始状態
        //03 : 対応再開状態
        //04 : 入力不可状態
        switch (data.supportedStatus) {
            case "0":

                this.setState({ inputMessageAreaStatus: "02" });
                break;
            case "1":
                //対応中のデータでそれが自分が対応中のユーザの場合
                if(identifier === "USER_LIST"){
                    (this.state.supportedPersonId === data.supportedPersonId)?this.setState({ inputMessageAreaStatus: "01" }):this.setState({ inputMessageAreaStatus: "04" });
                }else if(identifier === "POST_TEMPLATE"){
                    this.setState({ inputMessageAreaStatus: "01" });
                }
                break;

            case "7":
                this.setState({ inputMessageAreaStatus: "03" });
                break;

            case "6":
            case "8":
            case "9":
                this.setState({ inputMessageAreaStatus: "04" });
                break;

            default:
                break;
        }

    }

    //-----------------------------------------------------------------
    // 指定したチャット情報番号の対応を開始する
    //-----------------------------------------------------------------
    putStartCounseling = () => {
        const { cookies } = this.props;
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');
        axios.post(
            `${Common.apiServerUrl()}/api/counseling/putStartCounseling`,
            {
                supportedPersonId: this.state.supportedPersonId,
                counselingInfoNumber: this.state.selectedCounselingInfoNumber,
                userId: this.state.selectedUserId
            },
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
            }
        )
        .then(Common.handleErrors)
        .then(putStartCounselingResponse => {
            //successはbool型
            if (putStartCounselingResponse.success) {
                this.setState({ inputMessageAreaStatus: "01" });
                this.setState({ supportedStatusName: "対応中" });
                // this.updateUserList();
                this.updateUserList()
            } else {
                alert(`code : [${putStartCounselingResponse.code}]\nmessage : ${putStartCounselingResponse.error_usermsg}`);
            }
        })
        .catch(err => {
            console.log(err);
            if (Object.keys(err).indexOf('data') !== -1) {
                alert(`code : [${err.code}]\nmessage : ${err.error_usermsg}`);
            } else {
                alert(`code : [putStartCounseling]\nmessage : エラーが発生しました。サポートに連絡してください。`);
            }
        })
    }

    //-----------------------------------------------------------------
    // 指定したチャット情報番号の対応を再開にする
    //-----------------------------------------------------------------
    putReStartCounseling = () => {
        const { cookies } = this.props;
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');
        axios.post(
            `${Common.apiServerUrl()}/api/counseling/putRestartCounseling`,
            {
                supportedPersonId: this.state.supportedPersonId,
                counselingInfoNumber: this.state.selectedCounselingInfoNumber,
                userId: this.state.selectedUserId
            },
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
            }
        )
        .then(Common.handleErrors)
        .then(putReStartCounselingResponse => {
            //successはbool型
            if (putReStartCounselingResponse.success) {
                // this.updateUserList();
                this.updateUserList()
                this.setState({ inputMessageAreaStatus: "01" });
                this.setState({ supportedStatusName: "対応中" });
            } else {
                alert(`code : [${putReStartCounselingResponse.code}]\nmessage : ${putReStartCounselingResponse.error_usermsg}`);
            }
        })
        .catch(err => {
            console.log(err);
            if (Object.keys(err).indexOf('data') !== -1) {
                alert(`code : [${err.code}]\nmessage : ${err.error_usermsg}`);
            } else {
                alert(`code : [putStartCounseling]\nmessage : エラーが発生しました。サポートに連絡してください。`);
            }
        })
    }

    //-----------------------------------------------------------------
    // 入力された中断理由を更新する。
    //-----------------------------------------------------------------
    putStatusMessageArea = (memo) => {
        const { cookies } = this.props;
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');
        //----------------------------
        // 定型文を送信
        //----------------------------
        axios.post(
            `${Common.apiServerUrl()}/api/counseling/putStatusMessageArea`,
            {
                supportedPersonId: this.state.supportedPersonId,
                counselingInfoNumber: this.state.selectedCounselingInfoNumber,
                userId: this.state.selectedUserId,
                interruptedCauseMemo: memo
            },
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
            }
        )
        .then(Common.handleErrors)
        .then(putStatusMessageArea => {
            //successはbool型
            if (putStatusMessageArea.success) {
                // this.getUnsupportedData();
                // this.getUserListData();
                this.setState({selectedInterruptedCauseMemo : memo});
                this.updateUserList();
            } else {
                alert(`code : [${putStatusMessageArea.code}]\nmessage : ${putStatusMessageArea.error_usermsg}`);
            }
        })
        .catch(err => {
            console.log(err);
            if (Object.keys(err).indexOf('data') !== -1) {
                alert(`code : [${err.code}]\nmessage : ${err.error_usermsg}`);
            } else {
                alert(`code : [putStartCounseling]\nmessage : エラーが発生しました。サポートに連絡してください。`);
            }
        })
    }

    //-----------------------------------------------------------------
    //  入力されているメッセージを送信する。
    //-----------------------------------------------------------------
    postMessage = () => {
        const { cookies } = this.props;
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');
        //----------------------------
        // 定型文を送信
        //----------------------------
        clearInterval(this.setIntervalId);
        axios.post(
            `${Common.apiServerUrl()}/api/message/postMessage`,
            {
                supportedPersonId: this.state.supportedPersonId,
                counselingInfoNumber: this.state.selectedCounselingInfoNumber,
                userId: this.state.selectedUserId,
                sendMessage: this.state.inputMessage
            },
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
            }
        )
        .then(Common.handleErrors)
        .then(postMessageResponse => {
            //正常終了するとボタンがクリック可能にする。
            this.buttonControlFlag = true;
            //successはbool型
            if (postMessageResponse.success) {
                this.handleClick_popUpAreaClose();
                this.setState({ inputMessage: "" });
                this.updateMessagesArray();
            } else {
                alert(`code : [${postMessageResponse.code}]\nmessage : ${postMessageResponse.error_usermsg}`);
                this.handleClick_popUpAreaClose();
                this.setState({ inputMessageAreaStatus: "04" });
            }
        })
        .catch(err => {
            //正常終了するとボタンがクリック可能にする。
            this.buttonControlFlag = true;
            if (Object.keys(err).indexOf('data') !== -1) {
                alert(`code : [${err.code}]\nmessage : ${err.error_usermsg}`);
            } else {
                alert(`code : [postMessage]\nmessage : エラーが発生しました。サポートに連絡してください。`);
            }
        })
    }

    handleChangeReloadTime = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    // タイマー処理
    tick() {
        if (this.state.secondsElapsed <= 0) {
            // データ取得
            // this.getData_();
            this.updateUserList();
            if (this._isMounted) {
                this.setState({ secondsElapsed: this.state.reloadTime });
            }
        } else {
            if (this._isMounted) {
                this.setState({ secondsElapsed: this.state.secondsElapsed - 1 });
            }
        }
    }

    // タイマー処理（開始）
    start() {
        if (!this.state.isStart) {
            this.interval = setInterval(this.tick, 1000);
            if (this._isMounted) {
                this.setState({
                    isStart: true
                });
            }
        }
    }

    // タイマー処理（停止）
    stop() {
        if (this.state.isStart) {
            clearInterval(this.interval);
            if (this._isMounted) {
                this.setState({
                    isStart: false
                });
            }
        }
    }

    // タイマー処理（リセット）
    reset() {
        clearInterval(this.interval);
        // タイマーリセット毎にユーザリストの更新
        // this.getData_();
        this.updateUserList();
        if (this._isMounted) {
            this.setState({
                secondsElapsed: 0,
                isStart: false,
            });
        }
    }

    //-----------------------------------------------------------------
    //                  ライフサイクルブロック
    //-----------------------------------------------------------------

    //-----------------------------------------------------------------
    // コンポーネントがマウントされた直後に実行
    //-----------------------------------------------------------------
    componentDidMount() {
        // データ取得
        this.getData();
        this._isMounted = true;
        this.start();
    }

    // コンポーネントがマウントされていない時
    componentWillUnmount() {
        this._isMounted = false;
    }

    //-----------------------------------------------------------------
    // メッセージを入力した際に呼ばれる。
    //-----------------------------------------------------------------
    handleChange_Input_Message = (e) => {
        this.setState({ inputMessage: e.target.value });
    }

    //-----------------------------------------------------------------
    // 検索するキーワードを入力した際に呼ばれる。
    //-----------------------------------------------------------------
    handleChange_input_searchingCounselingKeyword = (e) => {
        this.setState({ searchingCounselingKeyword : e.target.value},()=>{
            this.updateUserList();
            this.handleClick_messagesArray_reset();
        });
    }

    //-----------------------------------------------------------------
    // user定型文メニューを表示する
    //-----------------------------------------------------------------
    handleClick_userTemplateOpen = (e) => {
        if (this.state.selectedUserId === "") {
            return alert(`code : [No user selected]\nmessage : ${this.state.talkName}が選択されていません。`);
        }
        this.setState({ userTemplateOpenFlg: true, anchorEl: e.currentTarget });
    }

    //-----------------------------------------------------------------
    // system定型文メニューを表示する
    //-----------------------------------------------------------------
    handleClick_systemTemplateOpen = (e) => {
        if (this.state.selectedUserId === "") {
            return alert(`code : [No user selected]\nmessage : ${this.state.talkName}が選択されていません。`);
        }
        this.setState({ systemTemplateOpenFlg: true, anchorEl: e.currentTarget });
    }

    //-----------------------------------------------------------------
    // チャット区分が選択された際によばれる
    //-----------------------------------------------------------------
    handleChangeCounselingSelecter = () => event => {
        this.setState({ selectedCounselingKubunId: event.target.value },()=>{
            this.updateUserList();
            this.handleClick_messagesArray_reset();
        });
    }

    //-----------------------------------------------------------------
    // チェックボックスが選択された際によばれる
    //-----------------------------------------------------------------
    handleChangeCheckBox = (event) => {
        this.setState({ ...this.state, [event.target.name]: event.target.checked },()=>{
            this.updateUserList();
            this.handleClick_messagesArray_reset();
        });
    };

    //-----------------------------------------------------------------
    // user定型文メニューを閉じる
    //-----------------------------------------------------------------
    handleClick_userTemplateClose = (e) => {
        this.setState({ userTemplateOpenFlg: false, anchorEl: null });
    }

    //-----------------------------------------------------------------
    // system定型文メニューを閉じる
    //-----------------------------------------------------------------
    handleClick_systemTemplateClose = (e) => {
        this.setState({ systemTemplateOpenFlg: false, anchorEl: null });
    }

    //-----------------------------------------------------------------
    // 定型文が選択された際に呼ばれる(選択された定型文内容)
    //-----------------------------------------------------------------
    handleClick_selectTemplate = (data) => {
        this.setState({selectedTemplateId : ""});
        this.setState({selectedTemplateMessageType : ""});
        //ユーザが選択されていない場合はそのメッセージを伝える。
        if (this.state.selectedUserId === "") {
            return alert(`code : [No user selected]\nmessage : ${this.state.talkName}が選択されていません。`);
        }
        this.setState({inputMessage : data.templateContent,});
        this.setState({selectedTemplateId : data.templateId});
        this.setState({selectedTemplateMessageType : data.templateType});
        if(data.templateType === '1'){
            this.setState({ userTemplateOpenFlg: false, anchorEl: null });
        }else if(data.templateType === '2'){
            this.setState({ systemTemplateOpenFlg: false, anchorEl: null });
        }
    }

    //-----------------------------------------------------------------
    //文字列を指定文字数以降をカットし、…で表現
    //-----------------------------------------------------------------
    cutStirng = (string, index) => {
        if(string === null || string === undefined) return null;
        else if(string.length > index){
            return `${string.substring(0, index)}…`;
        }
        return string;
    };

    //-----------------------------------------------------------------
    // ユーザリストがクリックされた際に呼ばれる
    //-----------------------------------------------------------------
    handleClick_userList = (data) => {
        if(this.updateFlag){
            if(this.state.selectedCounselingInfoNumber !== data.counselingInfoNumber){
                //処理が終了するまで処理を受け付けなくする。
                this.updateFlag = false;

                clearInterval(this.setIntervalId);
                this.setState({messagesArray : []},()=>{
                    //選択中のチャット情報番号をセット
                    this.setState({ selectedCounselingInfoNumber: data.counselingInfoNumber },()=>{
                        this.getDisplayUserInfo();
                        //会話履歴取得
                        this.getMessagesArray();
                    });
                });

                //選択中のユーザ名をセット
                this.setState({ selectedUserName: data.consulterFullName });

                //選択中のユーザIDをセット
                this.setState({ selectedUserId: data.userId });

                //選択中のユーザのメモをセット
                this.setState({ selectedInterruptedCauseMemo: data.interruptedCauseMemo });
                this.setState({ selectedInterruptedCauseMemoLog : data.interruptedCauseMemo});
                this.setState({ memoInputAvailabilityFlag : false});
                this.setState({ supportedStatusName: data.supportedStatusName });
                this.setState({ selectedCounselingSupportedPersonId : data.supportedPersonId});
                this.updateInputMessageAreaStatus(data,"USER_LIST");
                //誤爆防止のためにメッセージを初期化
                this.setState({inputMessage : ""});
            }
        }
    }

    //-----------------------------------------------------------------
    // 中断理由メモを入力した際に呼ばれる。
    //-----------------------------------------------------------------
    handleChangeInputStatusMessage = (e) => {
        this.setState({ selectedInterruptedCauseMemo: e.target.value });
    }

    //-----------------------------------------------------------------
    // 中断理由メモの更新チェックを行う。
    //-----------------------------------------------------------------
    handleChangeStasusMessageUpdateCheck = () => {
        //更新があった場合のみ
        if (this.state.selectedInterruptedCauseMemo !== this.state.selectedInterruptedCauseMemoLog) {
            //更新チェック
            var res = window.confirm('メモを更新しますか？');
            if(res === true){
                // OKなら移動
                this.putStatusMessageArea(this.state.selectedInterruptedCauseMemo);
            }else{
                this.setState({selectedInterruptedCauseMemo : this.state.selectedInterruptedCauseMemoLog});
            }
        }
    }

    //-----------------------------------------------------------------
    //メモ入力欄 自分が対応していないチャットはくりっくできないように
    //-----------------------------------------------------------------
    changeAvailabilityFlag = () => {

        if(this.state.selectedUserId === ""){
            return alert(`code : [No user selected]\nmessage : ${this.state.talkName}が選択されていません。`);
        }

        //選択しているチャットの対応者
        if(this.state.supportedPersonId !== this.state.selectedCounselingSupportedPersonId ){
            return  alert(`code : [Unable to edit]\nmessage : 対応者のみ編集可能です。`);
        }
        //ここの文字列は変更前
        // 変更前と変更後で変更がある場合のみpropsの関数を実行したい
        // if (this.state.inputAvailabilityFlag) {
        //     this.props.handleChangeStasusMessageUpdateCheck();
        // }
        if(this.state.memoInputAvailabilityFlag){
            this.handleChangeStasusMessageUpdateCheck();
        }
        this.setState({memoInputAvailabilityFlag : !this.state.memoInputAvailabilityFlag})
        // this.setState({ inputAvailabilityFlag: !this.state.inputAvailabilityFlag });

    }

    //-----------------------------------------------------------------
    // 閉じるがクリックされた際に呼ばれる
    //-----------------------------------------------------------------
    handleClick_messagesArray_reset = () => {
        this.setState({ messagesArray: [] });
        this.setState({ selectedCounselingInfoNumber: "" });
        this.setState({ selectedUserName: "" });
        this.setState({ inputMessage: "" });
        this.setState({ selectedUserId: "" });
        this.setState({ selectedInterruptedCauseMemo: "" });
        this.setState({ selectedInterruptedCauseMemoLog: "" });
        this.setState({ supportedStatusName: "未選択" });
        this.setState({ checkedPastCounseling : false});
        this.setState({ memoInputAvailabilityFlag : false});
        this.setState({ selectedCounselingSupportedPersonId : ""});

        let resetUserData = {
            fullName:"",
            counselingKubunName:"",
            chatTitle:"",
            questionTitle:"",
            question:"",
            questionCategory:""
        };
        this.setState({selectedCounselingUserData : resetUserData});
        this.updateUserList();
        //別なチャット情報番号の会話履歴が取得された場合。
        clearInterval(this.setIntervalId);
    }

    //-----------------------------------------------------------------
    // 送信がクリックされた際に呼ばれる
    //-----------------------------------------------------------------
    handleClick_sendMessage = () => {
        if(this.buttonControlFlag){
            //処理が終了するまで送信ボタンを押せないようにする。
            this.buttonControlFlag = false;
            // alert("handleClick_sendMessage : clicked");
            if (this.state.selectedUserId === "") {
                return alert(`code : [No user selected]\nmessage : ${this.state.talkName}が選択されていません。`);
            } else if (this.state.inputMessage.length > 2000) {
                return alert(`code : [Input Error]]\nmessage : 文字数が2000文字を超えています。`);
            }

            //テキストの場合はそのまま送信
            if(this.state.selectedTemplateMessageType === "1"){
                this.postMessage();
            //テキストならそのまま送信
            }else if(this.state.selectedTemplateMessageType === "2"){
                this.postTemplate();
            //それ以外：現在なし
            }else{
                this.postMessage();
            }
        }
    }

    //ユーザの過去のチャット検索ボタンがclickされた際に呼ばれる。
    handleChange_pastCounselingButton = () => {
        if (this.state.selectedUserId === "") {
            return alert(`code : [No user selected]\nmessage : ${this.state.talkName}が選択されていません。`);
        }

        //検索中のユーザIDを更新、終了を待ってから、過去のやり取り取得APIを呼ぶ
        this.setState({
            checkedPastCounseling : !this.state.checkedPastCounseling
        },
        ()=>{
            if(!this.state.checkedPastCounseling)this.handleClick_messagesArray_reset();
            this.updateUserList();
        });
    }

    //-----------------------------------------------------------------
    // 対応開始がクリックされた際に呼ばれる
    //-----------------------------------------------------------------
    handleClick_supportStart = () => {
        //送信してよいか確認を行う。
        //ユーザが選択されていない場合はそのメッセージを伝える。
        if (this.state.selectedUserId === "") {
            return alert(`code : [No user selected]\nmessage : ${this.state.talkName}が選択されていません。`);
        }
        this.putStartCounseling();
    }

    //-----------------------------------------------------------------
    // 対応再開がクリックされた際に呼ばれる
    //-----------------------------------------------------------------
    handleClick_supportReStart = () => {
        if (this.state.selectedUserId === "") {
            return alert(`code : [No user selected]\nmessage : ${this.state.talkName}が選択されていません。`);
        }
        this.putReStartCounseling();
    }

    //-----------------------------------------------------------------
    // テキスト入力欄の拡張ボタンがクリックされた際に呼ばれる
    //-----------------------------------------------------------------
    handleClick_inputAreaOpen = () => {
        if (this.state.selectedUserId === "") {
            return alert(`code : [No user selected]\nmessage : ${this.state.talkName}が選択されていません。`);
        }
        this.setState({ expansionInputTextAreaOpenFlag: true });
    }
    //-----------------------------------------------------------------
    // ポップアップ拡張エリアを閉じる際に呼ばれる
    //-----------------------------------------------------------------
    handleClick_popUpAreaClose = () => {
        if (this.state.selectedUserId === "") {
            return alert(`code : [No user selected]\nmessage : ${this.state.talkName}が選択されていません。`);
        }
        this.setState({inputMessage : ""});
        this.setState({selectedTemplateId : ""});
        this.setState({selectedTemplateMessageType : ""});
        this.setState({ expansionInputTextAreaOpenFlag: false });
    }

    handleTooltipClose = () => {
        this.setState({tooltipOpen : false});
    };

    handleTooltipOpen = () => {
        this.setState({tooltipOpen : true});
    };

    //-----------------------------------------------------------------
    // 表示ブロック
    //-----------------------------------------------------------------
    render() {
        const { classes, cookies } = this.props;
        const { counselingKubunArray, userListsArray, selectedCounselingKubunId,
            checkedEnd, checkedNonSelf,userTemplatesArray, systemTemplatesArray,
            selectedTemplateId,　selectedTemplateMessageType, selectedUserName,
            inputMessage, selectedInterruptedCauseMemo, inputMessageAreaStatus,
            supportedStatusName, expansionInputTextAreaOpenFlag,
            selectedCounselingUserData, searchingCounselingKeyword, tooltipOpen, selectedCounselingInfoNumber } = this.state;

        const { reloadTime } = this.state;

        const supportedPersonId = cookies.get('supportedPersonId');
        const supporterFullName = cookies.get('supporterFullName');
        const commonNameObj = cookies.get('COMMON_NAME_OBJ');
        document.title = commonNameObj !== undefined ? commonNameObj.CHAT_NAME : '1対1チャット';
        const allSupportedPersonGetFlg = cookies.get('allSupportedPersonGet');
        const userName = commonNameObj !== undefined ? commonNameObj.USER_NAME : 'ニックネーム';
        const addressName = commonNameObj !== undefined ? commonNameObj.ADDRESS_NAME : '認証番号';
        const talkName = commonNameObj !== undefined ? commonNameObj.TALK_NAME : 'チャット';
        //ここでリターンすると、他の値まで返却されてしまうため、一旦オフ
        if (supportedPersonId === "" || supportedPersonId === undefined ||
            supporterFullName === "" || supporterFullName === undefined) {
            window.location.href = '/';
            return;
        }

        return (
            <Grid container justifyContent={'center'}>
                <Grid item xs={12} md={5} lg={4} xl={3}>
                    <Paper className={classes.chat_paper_top}>
                        <Typography
                            variant="body2"
                            className={classes.chat_paper_userName}
                        >
                            {`${selectedUserName === "" ? "未選択" : this.cutStirng(selectedUserName, 10)}`}
                        </Typography>
                        <ClickAwayListener onClickAway={() => this.handleTooltipClose()}>
                            <HtmlTooltip
                                className={classes.tooltip}
                                title={
                                    <React.Fragment>
                                        {/* DBから取得した値を表示する。 */}
                                        <p color="inherit">詳細情報</p>

                                        <b>{`${userName} :`}</b> {selectedCounselingUserData.fullName}
                                        <br />
                                        { selectedCounselingUserData.addressFlg && (
                                            <>
                                                <b>{`${addressName} :`}</b> {selectedCounselingUserData.addressNumber}
                                                <br />
                                                <b>{"ユーザーID :"}</b> {selectedCounselingUserData.userId}
                                                <br />
                                                <b>{"タイトル :"}</b> {selectedCounselingUserData.chatTitle}
                                                <br />
                                            </>
                                        )}
                                        { !selectedCounselingUserData.addressFlg && (
                                            <>
                                                <b>{"質問形式区分 :"}</b> {selectedCounselingUserData.questionCategory}
                                                <br />
                                                <b>{"質問内容 :"}</b> {selectedCounselingUserData.question}
                                                <br />
                                                <b>{"質問タイトル :"}</b> {selectedCounselingUserData.questionTitle}
                                                <br />
                                                <b>{"タイトル :"}</b> {selectedCounselingUserData.chatTitle}
                                                <br />
                                            </>
                                        )}
                                    </React.Fragment>
                                }
                                onClose={() => this.handleTooltipClose()}
                                open={tooltipOpen}
                                disableFocusListener
                                disableHoverListener
                                disableTouchListener
                            >
                                <div className={classes.info_icon_position}>
                                    <IconButton size="small" onClick={() => this.handleTooltipOpen()} color="inherit">
                                        <InfoIcon
                                            fontSize="small"
                                        />
                                    </IconButton>
                                </div>
                            </HtmlTooltip>
                        </ClickAwayListener>

                        <FormGroup className={classes.past_counselingButton}>
                            <FormControlLabel
                                control={<Switch checked={this.state.checkedPastCounseling} onChange={this.handleChange_pastCounselingButton} />}
                                label={<Typography variant="subtitle2">{`過去の${talkName}`}</Typography>}
                            />
                        </FormGroup>

                        {/* ここのデザインを対応状況に応じて変化させる */}
                        {supportedStatusName === "未選択" && (
                            <React.Fragment>
                                <div className={classes.supported_status + " " + classes.supported_status_notSelect}>
                                    <p className={classes.supported_status_p}>{supportedStatusName}</p>
                                </div>
                            </React.Fragment>
                        )}
                        {supportedStatusName === "未対応" && (
                            <React.Fragment>
                                <div className={classes.supported_status + " " + classes.supported_status_notSupport}>
                                    <p className={classes.supported_status_p}>{supportedStatusName}</p>
                                </div>
                            </React.Fragment>
                        )}
                        {supportedStatusName === "対応中" && (
                            <React.Fragment>
                                <div className={classes.supported_status + " " + classes.supported_status_supporting}>
                                    <p className={classes.supported_status_p}>{supportedStatusName}</p>
                                </div>
                            </React.Fragment>
                        )}
                        {supportedStatusName === "中断" && (
                            <React.Fragment>
                                <div className={classes.supported_status + " " + classes.supported_status_interruption}>
                                    <p className={classes.supported_status_p}>{supportedStatusName}</p>
                                </div>
                            </React.Fragment>
                        )}
                        {supportedStatusName === "返答なし" && (
                            <React.Fragment>
                                <div className={classes.supported_status + " " + classes.supported_status_end}>
                                    <p className={classes.supported_status_p}>{supportedStatusName}</p>
                                </div>
                            </React.Fragment>
                        )}
                        {supportedStatusName === "完了" && (
                            <React.Fragment>
                                <div className={classes.supported_status + " " + classes.supported_status_finish}>
                                    <p className={classes.supported_status_p}>{supportedStatusName}</p>
                                </div>
                            </React.Fragment>
                        )}
                        {supportedStatusName === "強制終了" && (
                            <React.Fragment>
                                <div className={classes.supported_status + " " + classes.supported_status_finish}>
                                    <p className={classes.supported_status_p}>{supportedStatusName}</p>
                                </div>
                            </React.Fragment>
                        )}

                    </Paper>
                    {/* ------------------------- */}
                    {/* チャットを表示するエリア (自作コンポーネント)*/}
                    {/* ------------------------- */}
                    <Paper className={classes.chat_paper_middle}>
                        <MessageView
                            messagesArray={this.state.messagesArray}
                            status={inputMessageAreaStatus}
                        />
                    </Paper>

                    {/* ------------------------- */}
                    {/* 送信テキスト入力欄まわり*/}
                    {/* ------------------------- */}
                    <Paper className={classes.chat_paper_bottom}>
                        {inputMessageAreaStatus === "01" && (
                            <React.Fragment>
                                <ValidatorForm
                                    ref="form"
                                    onSubmit={() => this.handleClick_sendMessage()}
                                >
                                    <div className={classes.flex}>
                                        <div className={classes.message_validator}>
                                        <TextValidator
                                            InputProps={{
                                                classes: {
                                                    input: classes.textField_font_risize,
                                                },
                                                style: {
                                                    fontSize: 12,
                                                    padding: '19.5px 14px'
                                                },
                                                inputProps:{
                                                    tabIndex:"1"
                                                }
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 14
                                                }
                                            }}
                                            className={classes.chat_width}
                                            label="メッセージを入力"
                                            maxRows="3"
                                            multiline={true}
                                            onChange={this.handleChange_Input_Message}
                                            name="Text"
                                            value={inputMessage}
                                            validators={['required', 'minStringLength:1','maxStringLength:2000']}
                                            errorMessages={['', '','']}
                                            width='100%'
                                            color='success'
                                        />
                                        </div>
                                        <Button
                                            className={classes.button_expansion_message_input_area}
                                            onClick={this.handleClick_inputAreaOpen}
                                            tabIndex="4"
                                        >
                                            <FullscreenIcon />
                                        </Button>
                                    </div>

                                    {/* 文字数 */}
                                    <Grid item xs={12} md={12} lg={12}></Grid>
                                    <div  className={classes.csv_button_area}>
                                        <CSVButton
                                            name={selectedCounselingUserData.fullName}
                                            counselingInfoNumber={selectedCounselingInfoNumber}
                                            counselingKubunArray={counselingKubunArray}
                                        />
                                    </div>
                                    <div  className={classes.bottom_button_area}>
                                        {/* 閉じるボタン*/}
                                        <Button variant="contained" className={classes.button_close} size="large" onClick={() => this.handleClick_messagesArray_reset()} tabIndex="3">
                                            {"閉じる"}
                                        </Button>

                                        {/* 送信ボタン*/}
                                        <Button variant="contained" type="submit" className={classes.button_send} size="large" tabIndex="2">
                                            {"送信"}
                                        </Button>
                                    </div>
                                </ValidatorForm>
                            </React.Fragment>
                        )}

                        {inputMessageAreaStatus === "02" && (
                            <React.Fragment>
                                <div className={classes.button_counseling_start_or_reStart}>
                                    <Button variant="contained" type="submit" className={classes.button_counseling_start} size="large" onClick={() => this.handleClick_supportStart()}>
                                        {"対応を開始する"}
                                    </Button>
                                </div>
                            </React.Fragment>

                        )}

                        {inputMessageAreaStatus === "03" && (
                            <React.Fragment>
                                <div className={classes.button_counseling_start_or_reStart}>
                                    <Button variant="contained" type="submit" className={classes.button_counseling_start} size="large" onClick={() => this.handleClick_supportReStart()}>
                                        {"対応を再開する"}
                                    </Button>
                                    <div  className={classes.csv_button_disable_area}>
                                        <CSVButton
                                            name={selectedCounselingUserData.fullName}
                                            counselingInfoNumber={selectedCounselingInfoNumber}
                                            counselingKubunArray={counselingKubunArray}
                                        />
                                    </div>
                                </div>
                            </React.Fragment>

                        )}

                        {inputMessageAreaStatus === "04" && (
                            <React.Fragment>
                                <div className={classes.button_counseling_start_or_reStart}>
                                    <Button variant="contained" className={classes.button_counseling_start} disabled={true} size="large">
                                        {`この${talkName}には対応できません`}
                                    </Button>
                                    <div  className={classes.csv_button_disable_area}>
                                        <CSVButton
                                            name={selectedCounselingUserData.fullName}
                                            counselingInfoNumber={selectedCounselingInfoNumber}
                                            counselingKubunArray={counselingKubunArray}
                                        />
                                    </div>
                                    {selectedCounselingUserData.chatId !== undefined && (
                                        <div  className={classes.csv_button_disable_area}>
                                            <SendButton chatId={selectedCounselingUserData.chatId}/>
                                        </div>
                                    )}
                                </div>
                            </React.Fragment>
                        )}

                    </Paper>
                </Grid>
                <Grid item xs={12} md={7} lg={8} xl={7}>
                    <Paper className={classes.userList_paper_top}>
                        <Typography variant="body2"
                            className={classes.userList_paper_string}
                        >
                            {`${talkName}履歴`}
                        </Typography>
                        {/* 更新の移行 */}
                        <FormControl className={classes.textField}>
                            <Select
                                className={classes.userList_counselingKubunName_select}
                                name="sample"
                                value={reloadTime}
                                onChange={this.handleChangeReloadTime('reloadTime')}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left',
                                    },
                                    getContentAnchorEl: null,
                                    classes: {
                                        paper: classes.pullDown_style,
                                    },
                                }}
                            >
                                {reloadTimesArray.map((data) => (
                                    <MenuItem value={data.value} key={data.value}>
                                        {data.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <div className={classes.input}>
                            <InputLabel htmlFor="outlined-age-native-simple">{this.state.secondsElapsed + "秒"}</InputLabel>
                        </div>
                    </Paper>
                    <Paper className={classes.userList_customize_area}>
                        <FormGroup row className={classes.userList_checkBox_area}>
                            <FormControlLabel
                                control={<Checkbox checked={checkedEnd} onChange={this.handleChangeCheckBox} name="checkedEnd" />}
                                label={<Typography variant="body2">完了済を表示</Typography>}
                            />
                            {allSupportedPersonGetFlg === 'TRUE' && (
                                <FormControlLabel
                                    control={<Checkbox checked={checkedNonSelf} onChange={this.handleChangeCheckBox} name="checkedNonSelf" />}
                                    label={<Typography variant="body2">全対応者表示</Typography>}
                                />
                            )}
                            <TextField
                                className={classes.margin}
                                id="input-with-icon-textfield"
                                label="キーワード検索"
                                value={searchingCounselingKeyword}
                                onChange={this.handleChange_input_searchingCounselingKeyword}
                                color='success'
                                InputProps={{
                                    startAdornment: (
                                        <SearchIcon/>
                                    )
                                }}
                            />
                        </FormGroup>

                        <div className={classes.counselingKubun_pullDown}>
                            <FormControl className={classes.userList_counselingKubunName_list}>
                                {/* <InputLabel htmlFor="outlined-age-native-simple">チャット区分を選択</InputLabel> */}
                                {/* 検索可能なドロップダウンにするか検討 */}
                                <Select
                                    className={classes.userList_counselingKubunName_select}
                                    name={"selectCounselingKubun"}
                                    value={selectedCounselingKubunId}
                                    onChange={this.handleChangeCounselingSelecter("selectedCounselingKubunId")}
                                    MenuProps={{
                                        anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        },
                                        transformOrigin: {
                                            vertical: 'top',
                                            horizontal: 'left',
                                        },
                                        getContentAnchorEl: null,
                                        classes: {
                                            paper: classes.pullDown_style,
                                        },
                                    }}
                                >
                                    {counselingKubunArray.map((data) => (
                                        <MenuItem value={data.counselingKubunId} key={data.counselingKubunId}>
                                            {data.counselingKubunName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </Paper>
                    {/* 右側のチャット一覧 */}
                    <Paper className={classes.userList_paper_middle}>
                        <UserList
                            talkName={talkName}
                            userListsArray={userListsArray}
                            handleClick_userList={this.handleClick_userList}
                        />
                    </Paper>
                    <Paper className={classes.userList_paper_bottom + " " + classes.flex}>
                        <StatusMessageArea
                            selectedInterruptedCauseMemo={selectedInterruptedCauseMemo}
                            memoInputAvailabilityFlag={this.state.memoInputAvailabilityFlag}
                            changeAvailabilityFlag={this.changeAvailabilityFlag}
                            handleChangeInputStatusMessage={this.handleChangeInputStatusMessage}
                        />
                    </Paper>
                </Grid>

                <Grid item xs={12} md={7} lg={8} xl={7}>
                    {/* 送信テキスト入力欄の拡張ポップアップ画面 */}
                    <Dialog aria-labelledby="customized-dialog-title" open={expansionInputTextAreaOpenFlag}>
                        <DialogTitle
                            className={classes.dialog_title}
                            id="customized-dialog-title"
                            onClose={() => this.handleClick_popUpAreaClose()}
                        >
                            <Typography
                                variant={"subtitle1"}
                            >
                                {`ユーザー : ${selectedUserName}`}
                            </Typography>
                        </DialogTitle>
                        <div className={classes.flex}>
                            <Button
                                className={classes.button_template + " " + classes.button_userTemplate_color}
                                aria-label="more"
                                aria-controls="user-menu"
                                aria-haspopup="true"
                                onClick={this.handleClick_userTemplateOpen}
                                tabIndex="5"
                            >
                                {"定型メッセージ"}
                            </Button>
                            <Button
                                className={classes.button_template + " " + classes.button_systemTemplate_color}
                                aria-label="more"
                                aria-controls="system-menu"
                                aria-haspopup="true"
                                onClick={this.handleClick_systemTemplateOpen}
                                tabIndex="6"
                            >
                                {"ステータス変更"}
                            </Button>
                        </div>

                        {/* ユーザ定型文を表示する部分 */}
                        <Menu
                            id="user-menu"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={this.state.userTemplateOpenFlg}
                            onClose={this.handleClick_userTemplateClose}
                            PaperProps={{
                                style: {
                                    maxHeight: 48 * 4.5,
                                    width: '20ch',
                                },
                            }}
                        >
                            {userTemplatesArray.map((data, key) => (
                                <MenuItem key={key} selected={data.templateId === selectedTemplateId} onClick={() => this.handleClick_selectTemplate(data)}>
                                    {data.title}
                                </MenuItem>
                            ))}
                        </Menu>

                        <Menu
                            id="system-menu"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={this.state.systemTemplateOpenFlg}
                            onClose={this.handleClick_systemTemplateClose}
                            PaperProps={{
                                style: {
                                    maxHeight: 48 * 4.5,
                                    width: '20ch',
                                },
                            }}
                        >
                            {systemTemplatesArray.map((data, key) => (
                                <MenuItem key={key} selected={data.templateId === selectedTemplateId} onClick={() => this.handleClick_selectTemplate(data)}>
                                    {data.title}
                                </MenuItem>
                            ))}
                        </Menu>

                        <DialogContent
                            className={classes.dialog_content}
                        >
                            <ValidatorForm
                                ref="form"
                                onSubmit={() => this.handleClick_sendMessage()}
                            >
                                <TextValidator
                                    InputProps={{
                                        classes: {
                                            input: classes.textField_font_risize,
                                        },
                                        style: {
                                            fontSize: 12,
                                            padding: '19.5px 14px',
                                            lineHeight: '1.55em'
                                        },
                                        inputProps:{
                                            tabIndex:"7"
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14
                                        }
                                    }}
                                    className={classes.chat_width}
                                    label="メッセージを入力"
                                    minRows="8"
                                    maxRows="8"
                                    multiline={true}
                                    onChange={this.handleChange_Input_Message}
                                    name="Text"
                                    value={inputMessage}
                                    // value={"inputMessage"}
                                    //システムメッセージ選択時は編集不可
                                    disabled = {(selectedTemplateMessageType === '2')? true : false}
                                    validators={['required', 'minStringLength:1','maxStringLength:2000']}
                                    errorMessages={['', '', '']}
                                    color='success'
                                />
                                <div className={classes.bottom_button_area_dialogVersion}>
                                    {/* 閉じるボタン*/}
                                    <Button variant="contained" onClick={() => this.handleClick_popUpAreaClose()} className={classes.button_close} size="large" tabIndex="9">
                                        {"閉じる"}
                                    </Button>

                                    {/* 送信ボタン*/}
                                    <Button variant="contained" type="submit" className={classes.button_send} size="large" tabIndex="8">
                                        {"送信"}
                                    </Button>
                                </div>
                            </ValidatorForm>
                        </DialogContent>
                    </Dialog>
                </Grid>
            </Grid>
        );
    }
}

Chat.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withCookies(Chat));